"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = __importStar(require("react"));
const InputSearch_1 = __importDefault(require("components/cosmos/InputSearch"));
const translate_1 = require("components/translate");
const debounce_1 = __importDefault(require("lodash/debounce"));
const flowRight_1 = __importDefault(require("lodash/flowRight"));
const mobx_react_1 = require("mobx-react");
const ClassService_1 = __importDefault(require("../ClassService"));
const timeout = 500;
const ClassListSearch = ({ search, t }) => {
    const fetchFormattedClassesRef = (0, react_1.useRef)((0, debounce_1.default)(ClassService_1.default.fetchFormattedClasses, timeout));
    const fetchFormattedClasses = fetchFormattedClassesRef.current;
    const handleChange = (event) => {
        const { value } = event.target;
        ClassService_1.default.setStoreData({ search: value });
        fetchFormattedClasses();
    };
    return ((0, jsx_runtime_1.jsx)(InputSearch_1.default, { value: search, onChange: handleChange, placeholder: t('class_manager.class_list.search_placeholder', {
            checkOnlineEvent: true
        }) }));
};
exports.default = (0, flowRight_1.default)((0, translate_1.translate)(), (0, mobx_react_1.inject)((stores) => ({
    search: stores.ClassStore.search
})))(ClassListSearch);
